"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArraySliceArguments = exports.cyclePointer = void 0;
const usePagination_constants_1 = require("./usePagination.constants");
/**
 * Use modulo here to cycle through the pages.
 * We add or subtract 1 to the current page number for next and previous respectively.
 * The remainder is always either 0 or the new page number.
 * If zero, then the page to be cycled to is the last page (aka the `totalPages` value)
 */
const cyclePointer = ({ direction, currentPointer, lastPointer, }) => {
    const increment = direction === usePagination_constants_1.PageChangeDirection.next ? 1 : -1;
    const remainder = (currentPointer + increment) % lastPointer;
    return remainder === 0 ? lastPointer : remainder;
};
exports.cyclePointer = cyclePointer;
/**
 * Given a pagesize and a specific page number
 * this method returns an array with the
 * first and second arguments to Array.prototype.slice
 */
function getArraySliceArguments({ page, pageSize, }) {
    const startIndex = (page - 1) * pageSize;
    const endIndex = (page - 1) * pageSize + pageSize;
    return [startIndex, endIndex];
}
exports.getArraySliceArguments = getArraySliceArguments;
//# sourceMappingURL=usePagination.utils.js.map